import React from "react";
import { ExpandIcon } from "../styles";

const customExpandIcon = ({
  expandable = [],
  expanded = false,
  onExpand,
  record = {},
}) => {
  if (!(expandable?.length > 0)) return <ExpandIcon className="null" />;
  if (expanded)
    return (
      <a style={{ textDecoration: "none" }} onClick={() => (expanded = false)}>
        <ExpandIcon className="fas fa-chevron-up blue" />
      </a>
    );
  else
    return (
      <a
        style={{ textDecoration: "none" }}
        onClick={(e) => onExpand(record, e)}
      >
        <ExpandIcon className="fas fa-chevron-down blue" />
      </a>
    );
};

export default customExpandIcon;
